import React, { useState } from 'react';
import { Radio, Zap, Signal, Wifi, ArrowRight, Check } from 'lucide-react';
import Imgbanner from '../components/images/eas/eas-banner.png'
import img1 from '../components/images/eas/1.png'
import img2 from '../components/images/eas/2.png'
import img3 from '../components/images/eas/3.png'
import img4 from '../components/images/eas/4.png'
import img5 from '../components/images/eas/5.png'
import img6 from '../components/images/eas/6.png'
import img7 from '../components/images/eas/rf/14.png'
import img8 from '../components/images/eas/rf/15.png'
import img9 from '../components/images/eas/rf/16.png'
import img10 from '../components/images/eas/rf/17.png'



const EASAntennaSection = () => {
  const [activeTab, setActiveTab] = useState('AM');

  const amAntennas = [
    {
        id: 1,
        name: 'IVORY AM 9023',
        description: 'High quality ABS antenna with curved design and extremely low false alarms',
        frequency: '58 kHz',
        material: 'ABS',
        features: ['High detection rate', 'Low false alarm', 'Curved design', 'Compatible with AM tags/labels'],
        image: img1
      
    },
    {
        id: 2,
        name: 'Carbon AM 8120',
        description: 'Next-generation AM detection technology with sleek modern styling',
        frequency: '58 kHz',
        material: 'ABS ',
        features: ['Next-gen detection', 'Sleek design', 'Jam/anti-interference protection (model-dependent)'],
        image: img2
    },
    {
        id :3,
        name: 'EDGE AM 9019',
        description: 'It’s a sleek security solution that prevents theft while doubling as a powerful advertising medium.',
        frequency: '58 kHz',
        material: 'acrylic',
        features: ['Security & Advertising Solution', 'Superior Detection', 'Smart Sensitivity'],
        image: img4
    },
    {
        id: 4,
        name: 'FROST AM 8120',
        description: 'Crafted with durable ABS material, this antenna combines strength and elegance, making it ideal for modern retail environments.',
        frequency: '58 kHz',
        material: 'ABS antenna',
        features: ['Durable Acrylic Design', 'Low Power Consumption ', 'Exceptional Detection'],
        image: img3
    },
    {
      id: 5,
      name: 'PLEXI AM 350',
      description: 'Engineered with premium acrylic material, delivers both durability and a modern, transparent design that blends into retail environment.',
      frequency: '58 kHz',
      material: 'Acrylic antenna',
      features: ['Smart Sensitivity Control', 'No External Controller', 'Flexible Installation Options'],
      image: img5

      
    },
    {
      id: 6,
      name: 'PLEXI AM 450',
      description: 'Built with premium-grade acrylic, this antenna offers a crystal-clear, modern design that perfectly complements any retail space',
      frequency: '58 kHz',
      material: 'Acrylic antenna',
      features: ['Flexible Installation Options', 'Smart Sensitivity Control', 'Premium Acrylic Design'],
      image: img6
      
    }
  ];

  const rfAntennas = [
    {
      id: 1,
      name: 'M609 DT-PLEXI',
      description: 'Crafted from high-quality acrylic, this RF EAS antenna ensures high detection with minimal false alarms.',
      frequency: '8.2MHz',
      material: 'Acrylic antenna',
      features: ['Superior detection', 'Premium acrylic construction', 'Excellent noise reduction'],
      image:img7
    },
    {
      id: 2,
      name: '6116 DT-SLIM',
      description: 'With dual-color LED lights and noise reduction technology, it delivers reliable performance and a sleek modern look',
      frequency: '8.2MHz',
      material: 'Aluminium and acrylic',
      features: ['Flexible installation configuration', 'Minimal false alarm', 'Customizable PCB board option'],
      image:img8
    },
    {
      id: 3,
      name: '6811 DT-SLEEK',
      description: 'Engineered for high detection accuracy and ultra-low false alarms, it keeps your products safe.',
      frequency: '8.2MHz',
      material: 'Aluminium and acrylic',
      features: ['Remote service', 'Super detection','Minimal false alarm'],
      image:img9
    },
    {
      id: 4,
      name: '6881 DT',
      description: 'With dual-color LED lights and advanced noise reduction, it’s not just protection – it’s innovation at its finest.',
      frequency: '8.2MHz',
      material: 'Acrylic system',
      features: ['Super detection', 'Build from sustainable materials', 'Customizable dual color LED'],
      image:img10
    }
  ];

  const ConcealedAntennas = [
    {
      id: 1,
      name:"Concealed Antennas",
      description:"",
      frequency:"",
      material:"",
      features: ['','',''],
      image:img10
    }
  ];

  const currentAntennas = activeTab === 'AM' ? amAntennas : rfAntennas;

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-teal-50 to-cyan-100 relative overflow-hidden font-poppins">
      {/* Animated background elements */}

        <div className="w-full h-full relative mt-5 font-poppins">
                    <img
                      src={Imgbanner}
                      alt="Banner"
                      className="w-full h-full object-cover"
                    />
                   
                    {/* Optional overlay text */}
        </div>

      <div className="absolute inset-0 opacity-40">
        <div className="absolute top-20 left-20 w-96 h-96 bg-emerald-300 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-20 w-80 h-80 bg-teal-300 rounded-full blur-3xl animate-pulse delay-1000"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-cyan-300 rounded-full blur-3xl animate-pulse delay-500"></div>
      </div>

      <div className="relative z-10 container mx-auto px-6 py-16">
        
        

        {/* Technology Toggle */}
        <div className="flex justify-center mb-16">
          <div className="bg-white/70 backdrop-blur-xl rounded-2xl p-2 border border-emerald-200 shadow-lg shadow-emerald-100">
            <div className="flex gap-2">
              {['AM', 'RF'].map((tech) => (
                <button
                  key={tech}
                  onClick={() => setActiveTab(tech)}
                  className={`flex items-center gap-3 px-8 py-4 rounded-xl font-semibold transition-all duration-300 ${
                    activeTab === tech
                      ? 'bg-gradient-to-r from-emerald-500 to-teal-600 text-white shadow-lg shadow-emerald-500/25'
                      : 'text-slate-600 hover:text-slate-800 hover:bg-white/50'
                  }`}
                >
                  {tech === 'AM' ? <Radio className="w-5 h-5" /> : <Wifi className="w-5 h-5" />}
                  {tech === 'AM' ? 'AM Technology' : 'RF Technology'}
                  <span className={`text-sm px-2 py-1 rounded-full ${
                    activeTab === tech 
                      ? 'bg-white/20 text-white' 
                      : 'bg-emerald-100 text-emerald-700'
                  }`}>
                    {/* {tech === 'AM' ? '5 Types' : '4 Types'} */}
                  </span>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Antenna Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-8 mb-16">
          {currentAntennas.map((antenna, index) => (
            <div
              key={antenna.id}
              className="group bg-white/60 backdrop-blur-xl rounded-3xl p-8 border border-emerald-100 hover:border-emerald-300 hover:bg-white/80 transition-all duration-500 hover:transform hover:scale-105 hover:shadow-2xl hover:shadow-emerald-500/10"
              style={{
                animationDelay: `${index * 150}ms`,
                animation: 'fadeInUp 0.8s ease-out both'
              }}
            >
              <div className="flex justify-between items-start mb-6">
                <div className="bg-gradient-to-r from-emerald-500 to-teal-600 rounded-2xl p-4 group-hover:shadow-lg group-hover:shadow-emerald-500/25 transition-all duration-300">
                  {activeTab === 'AM' ? 
                    <Radio className="w-8 h-8 text-white" /> : 
                    <Zap className="w-8 h-8 text-white" />
                  }
                </div>
                <div className="text-right">
                  {/* <div className="text-3xl font-bold text-slate-800 mb-1">{antenna.price}</div> */}
                  <div className="text-sm text-slate-500">Professional Grade</div>
                </div>
              </div>

              <h3 className="text-2xl font-bold text-slate-800 mb-3 group-hover:text-emerald-600 transition-colors duration-300">
                {antenna.name}
              </h3>
              
              <p className="text-slate-600 mb-6 leading-relaxed">
                {antenna.description}
              </p>

              <div>
                  <img src={antenna.image} className=''></img>

              </div>

              <div className="space-y-4 mb-8">
                <div className="flex justify-between py-2 border-b border-emerald-100">
                  <span className="text-slate-500">Frequency Range</span>
                  <span className="text-slate-800 font-medium">{antenna.frequency}</span>
                </div>
                <div className="flex justify-between py-2 border-b border-emerald-100">
                  <span className="text-slate-500">Material</span>
                  <span className="text-slate-800 font-medium">{antenna.material}</span>
                </div>
                
              </div>

              <div className="space-y-3 mb-8">
                {antenna.features.map((feature, idx) => (
                  <div key={idx} className="flex items-center gap-3">
                    <Check className="w-5 h-5 text-emerald-500 flex-shrink-0" />
                    <span className="text-slate-600">{feature}</span>
                  </div>
                ))}
              </div>

              <button className="w-full bg-gradient-to-r from-emerald-600 to-teal-700 hover:from-emerald-500 hover:to-teal-600 text-white font-semibold py-4 px-6 rounded-2xl transition-all duration-300 flex items-center justify-center gap-3 group-hover:shadow-lg group-hover:shadow-emerald-500/25">
                <span>View Specifications</span>
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
              </button>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center bg-white/60 backdrop-blur-xl rounded-3xl p-12 border border-emerald-100 shadow-lg shadow-emerald-100">
          <h2 className="text-4xl font-bold text-slate-800 mb-6">
            Need Custom Solutions?
          </h2>
          <p className="text-xl text-slate-600 mb-8 max-w-2xl mx-auto">
            Our engineering team can design custom antenna systems tailored to your specific emergency alert requirements and coverage needs.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-gradient-to-r from-emerald-600 to-teal-700 hover:from-emerald-500 hover:to-teal-600 text-white font-semibold py-4 px-8 rounded-2xl transition-all duration-300 flex items-center justify-center gap-3">
              <Signal className="w-5 h-5" />
              Contact Engineering
            </button>
            <button className="bg-white/70 hover:bg-white/90 text-slate-700 font-semibold py-4 px-8 rounded-2xl transition-all duration-300 border border-emerald-200 hover:border-emerald-300">
              Download Catalog
            </button>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default EASAntennaSection;